import { ContentApi } from "@/api/content";
import { ShopApi } from "@/api/shop";
import { config } from "@/config/config";
import { GetServerSideProps } from "next";
import Home from ".";

export const getServerSideProps: GetServerSideProps = async ({ preview = false }) => {
  let productList: ProductShopListDto[] = [];
  let categoryList: ShopCategoryListSimplifiedDto[] = [];
  let blogList: PostBlogListDto[] = [];
  let highlightsList: PostHighlightsListDto[] = [];
  let faqList: PostPublicFaqListDto[] = [];

  try {
    await ShopApi.GetProductShopList({
      limit: 4,
      fixed: true,
    }).then((ret) => {
      productList = ret.result;
    });
  } catch (ex) {}

  try {
    await ShopApi.CategoryListSimplified({ noPagination: true }).then((ret) => {
      categoryList = ret.result;
    });
  } catch (ex) {}

  try {
    await ContentApi.GetBlogList({ limit: 3, channels: [config.contentChannelHome] }).then((ret) => {
      blogList = ret.result;
    });
  } catch (ex) {}

  try {
    await ContentApi.GetHighlightsList({ limit: 1 }).then((ret) => {
      highlightsList = ret.result;
    });
  } catch (ex) {}

  try {
    await ContentApi.getFaqs({ channels: [config.contentChannelFaqHome] }).then((res) => {
      faqList = res.data;
    });
  } catch (ex) {}

  return {
    props: {
      productList: productList,
      categoryList: categoryList,
      blogList: blogList,
      highlightsList: highlightsList,
      faqList: faqList,
    },
  };
};

type Props = {
  productList: ProductShopListDto[];
  categoryList: ShopCategoryListSimplifiedDto[];
  blogList: PostBlogListDto[];
  highlightsList: PostHighlightsListDto[];
  faqList: PostPublicFaqListDto[];
};

export default function Temporario({ productList, categoryList, blogList, highlightsList, faqList }: Props) {
  return <Home productList={productList} categoryList={categoryList} blogList={blogList} highlightsList={highlightsList} faqList={faqList} />;
}

